export default {
  root: {
    '& > button': {
      color: '#e6007a',
    },
  },
};
